"use strict";
/**
 * @license
 * Copyright 2021 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Endianness, ENDIANNESS } from "#src/util/endian.js";
const denormMin = 2 ** -1074;
const float64Buf = new Float64Array(1);
const uint32Buf = new Uint32Array(float64Buf.buffer);
export function nextAfterFloat64(x, y) {
  if (Number.isNaN(x) || Number.isNaN(y)) return NaN;
  if (x === y) return y;
  if (x === 0) {
    return y < 0 ? -denormMin : denormMin;
  }
  float64Buf[0] = x;
  const lowIndex = ENDIANNESS === Endianness.LITTLE ? 0 : 1;
  const highIndex = 1 - lowIndex;
  if (y > x === x > 0) {
    if (uint32Buf[lowIndex] === 4294967295) {
      uint32Buf[lowIndex] = 0;
      uint32Buf[highIndex] += 1;
    } else {
      uint32Buf[lowIndex] += 1;
    }
  } else {
    if (uint32Buf[lowIndex] === 0) {
      uint32Buf[lowIndex] = 4294967295;
      uint32Buf[highIndex] -= 1;
    } else {
      uint32Buf[lowIndex] -= 1;
    }
  }
  return float64Buf[0];
}
